import { render, staticRenderFns } from "./RealWeightForm.vue?vue&type=template&id=b019cb88&scoped=true"
import script from "./RealWeightForm.vue?vue&type=script&lang=js"
export * from "./RealWeightForm.vue?vue&type=script&lang=js"
import style0 from "./RealWeightForm.vue?vue&type=style&index=0&id=b019cb88&prod&scoped=true&lang=css"
import style1 from "./RealWeightForm.vue?vue&type=style&index=1&id=b019cb88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b019cb88",
  null
  
)

export default component.exports